export default __webpack_public_path__ + "static/media/VD4.3ea56da0.png";